import { DeviceParamsDto, VehicleDto } from '@fleet-beat/api';

export interface DeviceDto {
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  id?: string;
  companyId?: string;
  truckId?: string;
  name?: string;
  networkStatus?: string;
  isActive?: boolean;
  serialNumber?: string;
  pinCode?: string;
  version?: string;
  description?: string;
  truck?: VehicleDto;
  params?: DeviceParamsDto[];

  lastSync?: string;
}
